import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AddressPropType } from '../../../prop-types/address';
import Address from '../../address';
import { FormattedMessage } from 'react-intl';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Button } from 'ui-components/components/button';
import { ShipTogetherNotes } from './ship-together-notes';
import style from './ship-together-destination-modal.module.less';
import DataDrivenLogo from '../../data-driven-logo';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

const selectedShipment = (marketplaceId, orderNumber) => {
  return (
    <div className={style['selected-header']}>
      <span className={style['selected-order-number']}>
        <span className={style['store-logos']}>
          <DataDrivenLogo className={style['store-icon']} logoType='icon' marketplaceId={Number.parseInt(marketplaceId, 10)} />
        </span>
        <span>{orderNumber}</span>
      </span>
      <div className={style['selected-surviving-order']}>
        <FormattedMessage
          defaultMessage='This will be the surviving shipment information'
          description='shipTogetherDestinationModal.survivingOrder'
          id='Y7fQ/s'
        />
      </div>
    </div>
  );
};

const nonSelectedShipments = (marketplaceId, orderNumber, numOfItems) => {
  return (
    <div className={style['other-headers']}>
      <span className={style['other-order-numbers']}>
        <span className={style['store-logos']}>
          <DataDrivenLogo className={style['store-icon']} logoType='icon' marketplaceId={Number.parseInt(marketplaceId, 10)} />
        </span>
        <span className={style['other-order-numbers']}>{orderNumber}</span>
      </span>
      <div className={style['shipments-to-add']}>
        <span className={style['num-of-items']}>
          <FormattedMessage
            defaultMessage='{numOfItems, plural, =0 {# items} one {# item} other {# items}}'
            description='shipTogetherDestinationModal.numOfItems'
            id='hIqM5S'
            values={{ numOfItems }}
          />
        </span>
        <span className={style['will-be-added']}>
          <FormattedMessage
            defaultMessage='will be added to the combined shipment'
            description='shipTogetherDestinationModal.willBeAdded'
            id='473n1G'
          />
        </span>
      </div>
    </div>
  );
};

export const FulfillmentPlanSelector = ({
  address = emptyObject,
  onFulfillmentPlanSelected,
  notes = emptyArray,
  selectedService = '',
  fulfillmentPlanId = 0,
  isSelected = false,
  orderNumber = '',
  numOfItems = 0,
  marketplaceId = '0',
}) => {
  const selectedClass = classnames({
    [style['shipment-selector']]: true,
    [style['selected-shipment']]: isSelected,
  });
  return (
    <Button className={selectedClass} onClick={() => onFulfillmentPlanSelected(fulfillmentPlanId.toString())} theme='unstyled'>
      <RadioCheckListItem
        className={style['shipment-selector-radio']}
        isChecked={isSelected}
        onChecked={() => onFulfillmentPlanSelected(fulfillmentPlanId.toString())}
      />
      <div className={style['shipment-selector-section']}>
        <div className={style['shipment-header']}>
          {isSelected ? selectedShipment(marketplaceId, orderNumber) : nonSelectedShipments(marketplaceId, orderNumber, numOfItems)}
        </div>
        <div className={style['address-sections']}>
          <div className={classnames(style['shipment-labels'], style['address-label'])}>
            <FormattedMessage defaultMessage='Ship To' description='shipTogetherDestinationModal.shipTo' id='TxOyIf' />
          </div>
          <div className={style['address-info']}>
            <Address address={address} />
          </div>
        </div>
        {selectedService && (
          <div className={style['shipment-sections']}>
            <div className={style['shipment-labels']}>
              <FormattedMessage defaultMessage='Selected Service' description='shipTogetherDestinationModal.selectedService' id='bOr6IO' />
            </div>
            <div className={style['shipment-info']}>{selectedService}</div>
          </div>
        )}
        {notes.length !== 0 && <ShipTogetherNotes notes={notes} />}
      </div>
    </Button>
  );
};

FulfillmentPlanSelector.propTypes = {
  address: AddressPropType,
  onFulfillmentPlanSelected: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  notes: PropTypes.array,
  selectedService: PropTypes.string,
  fulfillmentPlanId: PropTypes.string,
  orderNumber: PropTypes.string,
  numOfItems: PropTypes.number,
  marketplaceId: PropTypes.string,
};
